 (function () {
 	const mediaBanner = () => {
        // if(document.querySelectorAll(".next_slide").length > 0) {}
				const stickyElements = document.querySelectorAll('.media-banner__content--top .media-banner__content-wrapper--sticky-top-content');

				if(stickyElements.length > 0) {
					window.addEventListener('scroll', function() {
						stickyElements.forEach(stickyElement => {
							const offset = stickyElement.offsetTop;
							const sticky_height = stickyElement.offsetHeight;
							const stickyParent = stickyElement.closest(".media-banner__slide");
							const sticky_parent_height = stickyParent.offsetHeight;

							const offset_to_disappear = sticky_parent_height - sticky_height;
					
							if ((window.scrollY > offset) && (window.scrollY < offset_to_disappear)) {
								stickyElement.style.position = 'fixed';
								stickyElement.style.top = '0';
							} else {
								stickyElement.style.position = 'relative';
							}
						});
					});
				}
     }


 	document.addEventListener("DOMContentLoaded", function () {
 		mediaBanner();
 		document.addEventListener("shopify:section:load", function () {
 			mediaBanner();
 		});
 	});
 })();
